"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _searchForm = require("../search-form");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var searchCompId = document.getElementById('search-comp');
var searchComp = document.getElementsByClassName('search-comp-class');
var activityPage = document.getElementById('container-activity');
var keywordPage = document.getElementById('container-keyword');
var cityPage = document.getElementById('container-city');
var activity;
var infoElement;
var locationValue = '';
var origin = 'home';
if (activityPage) {
  origin = 'activity page';
  infoElement = activityPage;
} else if (keywordPage) {
  origin = 'keyword page';
  infoElement = keywordPage;
} else if (cityPage) {
  origin = 'city page';
  infoElement = cityPage;
}
if (infoElement) {
  activity = infoElement.getAttribute('data-activity');
  var city = infoElement.getAttribute('data-city');
  var state = infoElement.getAttribute('data-state');
  var country = infoElement.getAttribute('data-country');
  locationValue = city ? state ? "".concat(city, ", ").concat(state) : "".concat(city, ", ").concat(country) : '';
}
var properties = {
  origin: origin
};
if (activity) {
  properties.activity = activity;
}
if (locationValue) {
  properties.locationValue = locationValue;
}
if (searchComp.length) {
  for (var i = 0; i < searchComp.length; i++) {
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_searchForm.SearchForm, properties), searchComp[i]);
  }
} else if (searchCompId) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_searchForm.SearchForm, properties), searchCompId);
}